import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="relative z-[3] px-8 py-8 text-center before:absolute before:top-0 before:left-1/2 before:h-px before:w-[200px] before:-translate-x-1/2 before:bg-gradient-to-r before:from-transparent before:via-primary/30 before:to-transparent dark:before:via-[rgba(0,255,150,0.3)]">
      <p className="m-0 text-sm text-gray-700 dark:text-white/70 [text-shadow:0_0_10px_rgba(59,130,246,0.2)] dark:[text-shadow:0_0_10px_rgba(0,255,150,0.2)]">
        © {currentYear} <span className="font-semibold text-primary dark:text-[rgba(0,255,150,0.9)]">Image Editor</span>. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;